import {Play, Summary} from "../Model/FirstAidKitState";
import {Homepage} from "../../Shared/Model/GameState";
import {ScoreData} from "../../Shared/Components/Score";

export default class FirstAidKitFactory {

    static homepage() : Homepage {
        return {
            screen : "homepage"
        }
    }

    static play() : Play {
        return {
            screen : "play",
        }
    }

    static summary(score: ScoreData) : Summary {
        return {
            screen : "summary",
            score: score
        }
    }

}